<template lang="pug">
.add-adult-process
  transition-group(name="fade")
    .status.pending(v-if="status===0" key="0")
      notification(:status="100" :msg="$t('addAdult.pending[0]')" :subMsg="$t('addAdult.pending[1]')")
    .status.success(v-if="status===1" key="1")
      notification(:status="200" :msg="$t('addAdult.success[0]')")
      //.name-card
        fam-card-view
          avatar-adult(:noAdd="true")
    .status.success(v-if="status===2" key="2")
      notification(:status="400" :msg="$t('addAdult.rejected[0]')")

    countdown-btn(v-if="status===1 || status === 2" key="3" :countdown="3" :copy="$t('btn.complete')")
  
</template>
<script>
import SocketService from '@/services/SocketService'
import FamCardView from '@/components/me/FamCardView'
import AvatarAdult from '@/components/me/AvatarAdult'
import victora from '@/assets/victora.png'
import { mapMutations, mapState, mapActions } from 'vuex'
import Notification from '@/components/wedgits/Notification'
import CountdownBtn from '@/components/wedgits/CountdownBtn'
export default {
  name: 'AddAdultProcess',
  components: {
    CountdownBtn,
    Notification,
    AvatarAdult,
    FamCardView,
  },
  props: {},
  data() {
    return {
      status: 0,
    }
  },
  computed: {
    ...mapState('app', ['user']),
  },
  methods: {
    ...mapMutations('app', ['addAdult']),
    ...mapActions('app', ['GetUser']),
    onMessage(data) {
      //window.alert(data)
      console.log('msg rec inside:', data)
      switch (data.code) {
        case SocketService.Events.QR_CONFIRMED: {
          this.onConfirm(data.data)
          break
        }
        case SocketService.Events.QR_REJECTED: {
          this.onReject(data.data)
          break
        }
      }
    },
    onConfirm(e) {
      console.log(e)
      // this.addAdult({
      //   nickname: 'Victora',
      //   avatar: victora,
      // })
      this.status = 1
      this.GetUser()
    },
    onReject() {
      this.status = 2
    },
    onError() {
      console.log('error!!!!')
      this.status = 400
    },
  },
  mounted() {
    // let prod = process.env.NODE_ENV === 'production'
    // if (prod) {
    // } else {
    //   setTimeout(() => {
    //     this.addAdult({
    //       nickname: 'Victora',
    //       avatar: victora,
    //     })
    //     this.status = 1
    //     setTimeout(() => {
    //       this.$refs.check.animeIn()
    //     }, 200)
    //   }, 4000)
    // }
    this.socket = SocketService.getInstance()
    this.socket.connect(this.user.id)
    this.socket.on(SocketService.Events.ONMESSAGE, this.onMessage)
    this.socket.on(SocketService.Events.ONERROR, this.onError)
  },
  beforeRouteLeave(to, from, next) {
    if (to.path !== '/reservation/addAdult') this.socket.close()
    next()
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.add-adult-process
  position: absolute
  top: 0
  left: 0
  width: 100%
  height: 100%
  //padding: 0 pxToRem(30)
  color: black
  overflow: hidden
  .status
    position: absolute
    top: pxToRem(64)
    left: 0
    text-align: center
    width: 100%
    display: flex
    align-items: center
    justify-content: center
    flex-direction: column
  .pending

  .success
    .name-card
      position: relative
      width: pxToRem(702)
      height: pxToRem(489)
      margin: pxToRem(100) auto

.fade-enter-active, .fade-leave-active
  transition: all 0.5s
.fade-enter
  transform: translateX(50%)
  opacity: 0
.fade-leave-to
  transform: translateX(-50%)
  opacity: 0
</style>
